/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PreloadInputs */



/**
* | output |
* | --- |
* | "Preload" |
*
* @param {PreloadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preload = /** @type {((inputs?: PreloadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PreloadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préchargement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Precarico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительная загрузка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Precarga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预加载")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीलोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-carga")
	return /** @type {LocalizedString} */ ("Preload")
});